import React, { useEffect } from "react";
import SiteNavbar from "../../components/navbar/SiteNavbar";
import Footer from "../../components/footer/Footer";
import { getSettings } from "../../services/webSite.services";
import { Styles } from "./styles";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setSettings } from "../../store/slices/settingSlice";
import {
  setIsLoading,
  setIsSettingsChanges,
  setProfileData,
} from "../../store/slices/studentSlice";
import { getStudentInfo } from "../../services/student.service";
import environment from "../../environment";

const PagesProvider = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();

  const isUserLoggedIn = localStorage.getItem(environment.TOKEN_KEY);

  // Get settings from store
  const data = useSelector((state) => state.setting);

  // Get settings from store
  const userData = useSelector((state) => state.student);

  const isLiveLesson =
    pathname.includes("live-lesson") || pathname.includes("join-v2");
  const isRecordedLiveLessonForMobile = pathname.includes(
    "recorded-live-lesson"
  );
  const isRecordedLiveLesson = pathname.includes("recorded-live-lesson/");
  const isActivity = pathname.includes("activity");
  const isLogin = pathname === "/login";
  const isResetPassword = pathname === "/reset-password";
  const isForgetPassword = pathname === "/forget-password";
  const isVerifyCode = pathname === "/verify-code";
  const isRegister = pathname === "/register";
  const isCourseRegister = pathname.includes("course-form");
  const isVerifyAccount = pathname === "/verify-account";
  const isCv = pathname === "/cv";
  const isPayment = pathname.includes("payment");
  const isEndSession = pathname.includes("end-session");

  const isCourseDetails = pathname.includes("course-details");
  const isHome = pathname === "/";

  const havNoLayout =
    isLogin ||
    isResetPassword ||
    isForgetPassword ||
    isVerifyCode ||
    isRegister ||
    isCourseRegister ||
    isVerifyAccount ||
    isCv ||
    isEndSession ||
    isRecordedLiveLessonForMobile;

  const getAllSettings = async () => {
    const response = await getSettings();
    if (response?.status === 200) {
      dispatch(setSettings(response?.data?.data));
    } else {
      dispatch(setLoading());
    }
  };

  // get user data from api
  const getData = async () => {
    const response = await getStudentInfo();
    if (response?.status === 200) {
      dispatch(setProfileData(response?.data?.data));
    } else {
      dispatch(setIsLoading());
    }
  };

  useEffect(() => {
    if (!data?.settings) {
      getAllSettings();
    }
  }, [data]);

  useEffect(() => {
    if (
      (!userData?.profileData || userData.isSettingsChanges) &&
      isUserLoggedIn
    ) {
      dispatch(setIsSettingsChanges(false));
      getData();
    }
  }, [userData]);

  useEffect(() => {
    if (!isPayment) {
      sessionStorage.getItem("discountData") &&
        sessionStorage.removeItem("discountData");

      sessionStorage.getItem("discountCode") &&
        sessionStorage.removeItem("discountCode");
    }
    if (!isPayment && !isCourseRegister) {
      sessionStorage.getItem("scheduleId") &&
        sessionStorage.removeItem("scheduleId");
    }
  }, [pathname]);

  return (
    <Styles>
      {isRecordedLiveLesson ? (
        <>
          <SiteNavbar initBG={true} />
          <div className="main-data">
            {children}
            <Footer />
          </div>
        </>
      ) : havNoLayout ? (
        children
      ) : isLiveLesson || isActivity ? (
        children
      ) : isHome || isCourseDetails ? (
        <>
          <SiteNavbar />
          <div className="main-data">
            {children}
            <Footer />
          </div>
        </>
      ) : (
        <>
          <SiteNavbar initBG={true} />
          <div className="main-data">
            {children}
            <Footer />
          </div>
        </>
      )}
    </Styles>
  );
};

export default PagesProvider;
